const r={ARROW_UP:"ArrowUp",ARROW_DOWN:"ArrowDown",ENTER:"Enter"};export{r as default};
